import { EngagementEventPayload, MixpanelEventData } from '@hcs/types';

import { useMixpanel } from './useMixpanel';

export const useTrackMixpanelEvent = () => {
  const mixpanel = useMixpanel();
  const trackMixpanelEvent = (engagementEvent: EngagementEventPayload) => {
    const eventData: MixpanelEventData = {
      app: engagementEvent.app,
      pageGroup: engagementEvent.pageGroup,
      httpPath: engagementEvent.httpPath,
      httpReferrer: engagementEvent.httpReferrer,
      authUserId: engagementEvent.authUserId,
      email: engagementEvent.email,
      authOrganizationSlug: engagementEvent.authOrganizationSlug,
      authOrganizationId: engagementEvent.authOrganizationId,
      ...engagementEvent.eventData,
    };

    mixpanel.track(engagementEvent.eventName, eventData);
  };
  return {
    mutate: trackMixpanelEvent,
  };
};
